
import React, { useState } from 'react';
import { Row, Col, Card, CardTitle, CardSubtitle, Button } from 'reactstrap';

//Components
import TextField from '../../../components/TextField';
import EsqueceuSenhaRestrito from './Components/EsqueceuSenhaRestrito';
import Loading from "../../../components/Loading/Loading";
import { useNavigate } from 'react-router-dom';

//Context
import { useAuth } from '../../../context/auth';

//Api
import usuario_api from '../../../api/usuario_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import Modulos from './Components/Modulos';

export default function Login() {
    const navigate = useNavigate();

    const { signIn, signOut, setLoading, loading, logoSistema, nomeSistema, subtituloLogin } = useAuth();

    //State para pegar dados de acesso
    const [acessos, setAcessos] = useState(null);

    //Estado de controle dos dados de login
    const [login, setLogin] = useState({
        login: "",
        password: ""
    });

    const [esqueceuSenha, setEsqueceuSenha] = useState(false);
    //Função de onChange dos campos da tela inicial
    const onChange = (e) => {
        const { name, value } = e.target;
        setLogin({
            ...login,
            [name]: value
        })
    }

    //Função que envia os dados do login para validação
    const onSubmit = () => {
        const _login = {...login};
        _login.login = _login.login.trim();
        _login.password = _login.password.trim();

        setLoading(true);
        usuario_api.authenticate(_login).then(response => {
            if (!response.data?.master) {
                response.data.acesso = "secretaria";
                signIn(response.data);
                navigate("/admin/dashboard");
            } else {
                signIn(response.data);
                setAcessos(response.data)
            }
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(() => setLoading(false));
    }

    if (esqueceuSenha)
        return <EsqueceuSenhaRestrito btnVoltar={() => setEsqueceuSenha(false)} />

    const handleReturnModulos = () => {
        setAcessos(null);
        signOut();
    }

    return <div>
        {loading && (<Loading />)}
        {acessos && <Modulos acessos={acessos} handleReturn={handleReturnModulos} />}
        {!acessos &&
            <div className='mainContainerLogin'>
                <Card className='w-75' style={{ marginTop: "10vh", border: "none", padding: "1rem" }}>
                    <Row className='p-4'>
                        <Col lg='6' md='12' className='text-center d-flex flex-column justify-content-center' style={{ borderRight: "1px solid #ccc" }}>
                            <div className="mb-3">
                                <img src={logoSistema} width={500} className='img-logo' alt="Logo do sistema GAIA" />
                            </div>
                            <CardTitle tag={'h5'} style={{ color: "#666" }} className='w-100 mb-2 font-weight-normal'>Seja bem vindo ao {nomeSistema}</CardTitle>
                            <CardSubtitle tag="p" style={{ color: "#ccc", fontSize: '12pt' }} className='mb-2'>
                                {subtituloLogin}
                            </CardSubtitle>
                        </Col>
                        <Col lg='6' md='12' className='text-center d-flex flex-column justify-content-around '>
                            <CardTitle tag={'h4'} className=' text-center' style={{ color: "#666" }}>Dados de acesso</CardTitle>
                            <TextField
                                label={"E-mail"}
                                name={"login"}
                                value={login.login}
                                onChange={onChange}
                            />
                            <TextField
                                label={"Senha"}
                                name={"password"}
                                type={'password'}
                                value={login.password}
                                onChange={onChange}
                            />
                            <div className='w-100 d-flex align-items-center justify-content-end text-secondary mb-3'>
                                <span role='button' onClick={() => setEsqueceuSenha(true)}>Esqueceu a senha?</span>
                            </div>
                            <div>
                                <Button color='success' style={{ width: "80%" }} onClick={onSubmit}>
                                    Entrar
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </div>
        }

    </div>
}